import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { PrivacySection } from '../../../features/settings/privacy-section'

export const Route = createFileRoute('/_app/settings/privacy')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'privacy'),
  component: PrivacySection,
})
